var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSaveSet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_save_set") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_save_set",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Mask",
    fill: "#445E6F",
    transform: "translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) ",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6936037,10.2163592 C12.1021321,10.6249143 12.1021321,11.2852898 11.6936037,11.6938449 C11.4898619,11.8976 11.2223855,12 10.9549091,12 C10.6874327,12 10.4199562,11.8976 10.2162145,11.6938449 L8.0001306,9.47761633 L5.78300193,11.6938449 C5.57926013,11.8976 5.31178372,12 5.04430731,12 C4.7768309,12 4.51039932,11.8976 4.30561269,11.6938449 C3.8981291,11.2852898 3.8981291,10.6249143 4.30561269,10.2163592 L6.52169654,8.00013061 L4.30561269,5.78390204 C3.8981291,5.37534694 3.8981291,4.71392653 4.30561269,4.30641633 C4.71414112,3.89786122 5.37551833,3.89786122 5.78300193,4.30641633 L8.0001306,6.5226449 L10.2162145,4.30641633 C10.6247429,3.89786122 11.2850753,3.89786122 11.6936037,4.30641633 C12.1021321,4.71392653 12.1021321,5.37534694 11.6936037,5.78390204 L9.47751984,8.00013061 L11.6936037,10.2163592 Z",
    id: "Path",
    fill: "#FFFFFF",
    transform: "translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveSet);
export default __webpack_public_path__ + "static/media/icon_save_set.ef4df842b86cc8645d128f58741a9ef8.svg";
export { ForwardRef as ReactComponent };